import { Box, Button, chakra, Text } from "@chakra-ui/react";

export const IconCircle = chakra(Box, {
  baseStyle: {
    bg: "#F5F5F5",
    borderRadius: "full",
    width: "80px",
    height: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

export const StyledButton = chakra(Button, {
  baseStyle: {
    w: "219px",
    fontSize: "16px",
    fontWeight: "600",
    h: "48px",
    borderRadius: "16px",
    px: "6",
  },
});

export const StyledText = chakra(Text, {
  baseStyle: {
    fontSize: "14px",
    color: "#2F2F34",
    fontWeight: "500",
    textAlign: "center",
    fontFamily: "Poppins",
  },
});
